//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  inject: ["main"]
};